<style scoped>
</style>

<template>
  <div>
    <Content :style="{background: '#fff',padding:'15px',margin:'10px'}" v-if="appList.length > 0">
      <Tabs type="card" v-model="currentId" @on-click="tabClick">
        <TabPane
          v-for="app in appList"
          :label="app.appname+'('+app.platform+')'"
          :key="app.id"
          :name="app.id"
        ></TabPane>
      </Tabs>
      <div v-if="(appList.length > 0) && showContent">
        <ipasubmit v-if="getApp.platform == 'ios'" :approwid="getApp.id"></ipasubmit>
        <apksubmit v-else-if="getApp.platform == 'android'" :approwid="getApp.id"></apksubmit>
        <h5ressubmit v-else :approwid="getApp.id"></h5ressubmit>
      </div>
    </Content>
    <div v-else-if="displayNoApps&&appList.length==0">
      <h1 style="text-align:center;font-size:30px;margin:50px">暂时无法发布版本，请先在应用管理中添加应用</h1>
    </div>
  </div>
</template>

<script>
import ipasubmit from "./ipasubmit";
import apksubmit from "./apksubmit";
import h5ressubmit from "./h5ressubmit";
export default {
  components: { ipasubmit, apksubmit, h5ressubmit },
  data() {
    return {
      //项目ID
      projectguid: this.$route.params.projectguid,
      //应用列表
      appList: [],
      currentId: "",
      displayNoApps: false,
      showContent: true
    };
  },
  computed: {
    getApp() {
      for (let i = 0; i < this.appList.length; i++) {
        if (this.appList[i].id == this.currentId) {
          return this.appList[i];
        }
      }
      return null;
    }
  },
  methods: {
    //==========================页面级别方法==========================
    //获取应用列表
    getAppList() {
      let _this = this;
      this.$http.get({
        method: "mqms/app/list",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.appList = data;
          if (data.length > 0) {
            _this.currentId = data[0].id;
          } else {
            _this.displayNoApps = true;
          }
        }
      });
    },
    tabClick() {
      this.showContent = false;
      let _this = this;
      this.$nextTick(() => {
        setTimeout(function() {
          _this.showContent = true;
        }, 100);
      });
    }
  },
  mounted() {
    this.getAppList();
  }
};
</script>